import React, { FC } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { removeClipFromList, selectIsInit } from '../../../state/clipList';
import {
  previewClip,
  stopClipPreview,
} from '../../../state/currentReviewingClip';
import {
  resetCurrentEditingClipIndex,
} from '../../../state/currentEditingClip';
import {
  PreviewIcon, StopIcon, DeleteIcon,
} from '../../Icon';
import Overlay from '../../Overlay';
import { IVideoClip } from '../../../../../api/vault/clipList';
import { IAppState } from '../../../../../state/reducers';

const Container = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
`;

interface IOwnProps {
  clipIndex: number;
  clip: IVideoClip;
}

interface IStateProps {
  clipList: any[];
  currentPlayingClip: any;
  currentReviewingClip: any;
}

interface IDispatchProps {
  previewClip: (clipIndex: number) => void;
  stopClipPreview: () => void;
  resetCurrentEditingClipIndex: () => void;
  removeClipFromList: (clip: IVideoClip) => void;
}

interface IProps extends IOwnProps, IStateProps, IDispatchProps { }

const ClipItemRight: FC<IProps> = (props: IProps) => {
  const deleteClip = () => {
    const {
      clip,
      resetCurrentEditingClipIndex,
      removeClipFromList,
    } = props;

    if (clip) {
      removeClipFromList(clip);
      resetCurrentEditingClipIndex();
    }
  };

  const {
    clipIndex,
    clip,
    currentPlayingClip: { index: playingIndex },
    currentReviewingClip: { index: reviewingIndex },
    previewClip,
    stopClipPreview,
  } = props;
  const isPlayingCliplist = playingIndex !== null;
  const isReviewingClip = reviewingIndex === clipIndex;
  const canDelete = !isReviewingClip && !clip.userId;
  return (
    <Container>
      {isReviewingClip ? (
        <StopIcon onClickHandler={stopClipPreview} />
      ) : (
        <PreviewIcon onClickHandler={() => previewClip(clipIndex)} />
      )}
      <DeleteIcon disabled={!canDelete} onClickHandler={canDelete ? deleteClip : () => { }} />

      <Overlay isInvisible={!isPlayingCliplist} />
    </Container>
  );
};

const mapStateToProps = (state: IAppState): IStateProps => ({
  clipList: selectIsInit(state) ? state.clipList.allClips : [],
  currentPlayingClip: state.currentPlayingClip,
  currentReviewingClip: state.currentReviewingClip,
});

const mapDispatchToProps: IDispatchProps = {
  previewClip,
  stopClipPreview,
  resetCurrentEditingClipIndex,
  removeClipFromList,
};

export default connect(mapStateToProps, mapDispatchToProps)(ClipItemRight);
